import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import {
  ReadServicesAndGoods,
  WriteServicesAndGoods,
} from "@/types/servicesAndGoods";

export const ServicesAndGoodsService = new APIService<
  ReadServicesAndGoods,
  WriteServicesAndGoods
>(API.Services);
export const fetchServicesAndGoodsList = ServicesAndGoodsService.getList;
export const fetchServicesAndGoods = ServicesAndGoodsService.get;
export const createServicesAndGoods = ServicesAndGoodsService.post;
export const updateServicesAndGoods = ServicesAndGoodsService.patch;
